import ButtonSettings from './element-settings/button'
import ColorSettings from './element-settings/color'
import BackgroundColorSettings from './element-settings/color'
import ImageSettings from './element-settings/image'
import LinkSettings from './element-settings/link'
import type { IconKey } from 'components/ui/icon'

type ToolbarButton = {
  label: string
  style: string
  icon?: IconKey
  title?: string
  ConfigComponent?: any
}

export const TEXT_TYPES: ToolbarButton[] = [
  {
    label: 'Large title',
    style: 'header-one',
  },
  {
    label: 'Title 1',
    style: 'header-two',
  },
  {
    label: 'Title 2',
    style: 'header-three',
  },
  {
    label: 'Title 3',
    style: 'header-four',
  },
  {
    label: 'Regular text',
    style: 'unstyled',
  }, // { label: 'H5', style: 'header-five' },
  // { label: 'H6', style: 'header-six' },
]
export const BLOCK_TYPES: ToolbarButton[] = [
  {
    label: 'Unordered list',
    style: 'unordered-list-item',
    icon: 'bulleted-list',
  },
  {
    label: 'Ordered list',
    style: 'ordered-list-item',
    icon: 'numbered-list',
  },
]
export const INLINE_TYPES: ToolbarButton[] = [
  {
    label: 'Bold',
    style: 'BOLD',
    icon: 'bold',
  },
  {
    label: 'Italic',
    style: 'ITALIC',
    icon: 'italic',
  },
  {
    label: 'Underline',
    style: 'UNDERLINE',
    icon: 'underline',
  },
]
export const ALIGNMENT_TYPES: ToolbarButton[] = [
  {
    label: 'Left',
    style: 'align-left',
    icon: 'align-left',
  },
  {
    label: 'Center',
    style: 'align-center',
    icon: 'align-center',
  },
  {
    label: 'Right',
    style: 'align-right',
    icon: 'align-right',
  },
  {
    label: 'Justify',
    style: 'align-justify',
    icon: 'align-justify',
  },
]
export const INLINE_ACTIONS: ToolbarButton[] = [
  {
    label: 'Clear styles',
    style: 'clear-styles',
    icon: 'format-clear',
    title: 'Clear styles',
  },
]
export const ENTITY_TYPES: ToolbarButton[] = [
  {
    label: 'Image',
    style: 'image',
    icon: 'image',
    title: 'Add new image',
    ConfigComponent: ImageSettings,
  },
  {
    label: 'Button',
    style: 'button',
    icon: 'disco-btn',
    title: 'Add new button',
    ConfigComponent: ButtonSettings,
  },
  {
    label: 'Link',
    style: 'link',
    icon: 'link',
    title: 'Add new link',
    ConfigComponent: LinkSettings,
  },
  {
    label: 'Remove link',
    style: 'remove-link',
    icon: 'remove-link',
    title: 'Remove link',
  },
]
export const MERGE_TAG_TYPES: ToolbarButton[] = [
  {
    label: 'First name',
    style: 'first-name-merge-tag',
  },
  {
    label: 'Last name',
    style: 'last-name-merge-tag',
  },
  {
    label: 'Full name',
    style: 'full-name-merge-tag',
  },
]
export const FONT_SIZES: number[] = [
  8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36,
]
export const FONT_SIZE_TYPES = FONT_SIZES.map(size => ({
  label: size.toString(10),
  style: size.toString(10),
}))
export const COLOR_TYPES: ToolbarButton[] = [
  {
    label: 'Color',
    style: 'color',
    icon: 'color-text',
    title: 'Change text color',
    ConfigComponent: ColorSettings,
  },
  {
    label: 'Background color',
    style: 'bgcolor',
    icon: 'color-fill',
    title: 'Change background color',
    ConfigComponent: BackgroundColorSettings,
  },
] // export const FORMAT_TYPES = [
//   label: ''
// ]
